import styled from '@emotion/styled';

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export { InputContainer };
